module.exports = __webpack_public_path__ + "img/socialmedia.588a6d0e.svg";